import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { timer, throwError } from 'rxjs';
import { retry } from 'rxjs/operators';
import { parseRetryAfterMs } from './retry-after.utils';

const DEFAULT_RETRY_MS = 2000;
const MAX_RETRIES = 3;

export const retryAfterInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: MAX_RETRIES,
      delay: (error) => {
        if (error instanceof HttpErrorResponse && error.status === 429) {
          const delayMs = parseRetryAfterMs(error.headers.get('Retry-After')) ?? DEFAULT_RETRY_MS;
          return timer(delayMs);
        }
        return throwError(() => error);
      },
    })
  );
};
